export type Viewport = { zoom: number; x: number; y: number };
export const fittedViewport: Viewport = { zoom: 1, x: 0, y: 0 };
export function constrainViewport(view: Viewport, fitted: { width: number; height: number }, stage: { width: number; height: number }): Viewport {
  const zoom = Math.max(1, Math.min(8, view.zoom));
  const limitX = Math.max(0, (fitted.width * zoom - stage.width) / 2);
  const limitY = Math.max(0, (fitted.height * zoom - stage.height) / 2);
  return { zoom, x: Math.max(-limitX, Math.min(limitX, view.x)), y: Math.max(-limitY, Math.min(limitY, view.y)) };
}
// Keep the image point under the two-finger midpoint fixed while zooming.
export function pinchViewport(start: Viewport, origin: { x: number; y: number }, center: { x: number; y: number }, ratio: number): Viewport {
  const zoom = Math.max(1, Math.min(8, start.zoom * ratio));
  return { zoom, x: center.x - (origin.x - start.x) * zoom / start.zoom, y: center.y - (origin.y - start.y) * zoom / start.zoom };
}
